

import http from "../http-common";
import { CreateNotificationRequest } from "../types/CreateNotificationRequest";
import { CreateNotificationResponse } from "../types/CreateNotificationResponse";
import { SearchNotificationsRequest } from "../types/SearchNotificationsRequest";
import { SearchNotificationsResponse } from "../types/SearchNotificationsResponse";

const createNotification = (requestBody: CreateNotificationRequest, token?: string) => {
  return http.post<CreateNotificationResponse>(
    '/api/Notify',
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  );
};

const searchNotifications = (requestBody: SearchNotificationsRequest, token?: string) => {
  return http.post<SearchNotificationsResponse>(
    '/api/Notify/search',
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  );
};

const downloadNotificationPdf = async (fileKey: string, token?: string): Promise<Blob> => {
  const response = await http.get(`/api/Notify/download/${encodeURIComponent(fileKey)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob'
  });
  return response.data;
};

const NotificationService = {
  createNotification,
  searchNotifications,
  downloadNotificationPdf
};

export default NotificationService;